// import React, { useEffect, useState,forwardRef, useImperativeHandle, useRef } from "react";
// import styled from "styled-components";
// import axios from "axios";

// const Wrapper = styled.div`
//   background: white;
//   padding: 2rem;
//   margin: 2rem auto;
//   width: 100%;
//   border-radius: 12px;
//   box-shadow: 0 4px 15px rgba(0,0,0,0.1);
//   text-align: center;

//   @media (max-width: 768px) {
//     width: 95%;
//     padding: 1rem;
//   }
// `;

// const Heading = styled.h3`
//   margin-bottom: 2rem;
//   font-size: 1.2rem;
//   color: #1e3a8a;
//   font-weight: bold;
//   text-align: left;
// `;

// const LineWrapper = styled.div`
//   position: relative;
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-start;
//   margin: 2rem 0 1rem;
//   padding: 0 20px;
//   flex-wrap: nowrap;

//   &::before {
//     content: "";
//     position: absolute;
//     top: 50%;
//     left: 10px;
//     right: 10px;
//     height: 4px;
//     background: #ddd;
//     z-index: 0;

//     @media (max-width: 768px) {
//       display: none; /* Hide line on small screens */
//     }
//   }

//   @media (max-width: 768px) {
//     flex-direction: column;
//     align-items: center;
//     margin: 2rem 0;
//     padding: 0 10px;
//   }
// `;

// const BoxWrapper = styled.div`
//   position: relative;
//   z-index: 1;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   margin-right: 1rem;

//   @media (max-width: 768px) {
//     margin-bottom: 1rem;
//   }
// `;

// const BoxValue = styled.div`
//   margin-bottom: 0.3rem;
//   font-weight: bold;
//   color: #333;
// `;

// const Box = styled.div`
//   width: 80px;
//   height: 30px;
//   background: ${(props) => props.color};
//   border-radius: 6px;

//   @media (max-width: 768px) {
//     width: 60px;
//     height: 25px;
//   }
// `;

// const BoxLabel = styled.div`
//   margin-top: 0.3rem;
//   font-size: 0.95rem;
//   color: #444;
// `;

// // const TotalLabel = styled.div`
// //   margin-top: 2rem;
// //   font-weight: bold;
// //   font-size: 1rem;
// //   color: #be6f72;
// //   text-align: left;
// //   display: flex;
// //   flex-wrap: wrap;
// //   gap: 0.5rem;

// //   @media (max-width: 768px) {
// //     flex-direction: column; /* Stack label and value vertically */
// //     font-size: 0.95rem;
// //   }
// // `;

// const TotalLabel = styled.div`
//   margin-top: 2rem;
//   font-weight: bold;
//   font-size: 1rem;
//   color: #1e3a8a;
//   text-align: left;
//   display: flex;
//   flex-wrap: wrap;
//   gap: 0.5rem;

//   @media (max-width: 768px) {
//     flex-direction: column;
//     font-size: 0.95rem;

//     span {
//       display: block;     
//       width: 100%;
//     }
//   }
// `;


// const MotorMonthlyRuntimeChart = forwardRef(({ motor_id, month, year, token }, ref) => {
//   const exportRef = useRef();
//   const [data, setData] = useState([]);
//   const [total, setTotal] = useState("");
//   const [loading, setLoading] = useState(true);

//       useImperativeHandle(ref, () => ({
//         getElement: () => exportRef.current,
//       }));

//   useEffect(() => {
//     async function fetchMonthlyData() {
//       if (!motor_id || !month || !year) return;

//       setLoading(true);
//       try {
//         const url = `${process.env.REACT_APP_API}/sensor/motor-monthly-runtime?motor_id=${motor_id}&month=${month}&year=${year}`;
//         const res = await axios.get(url, {
//           headers: { Authorization: token[0] },
//         });

//         const logs = res.data.logs || [];
//         setData(logs);
//         setTotal(res.data.total_monthly_run_time || "0 mins");
        
//       } catch (err) {
//         console.error("Error fetching monthly runtime:", err);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchMonthlyData();
//   }, [motor_id, month, year, token]);

//   if (loading) return <Wrapper>Loading monthly runtime...</Wrapper>;

// const colors = [
//   "linear-gradient(to left, #e0f7ff 0%, #81d4fa 100%)",  // Very Light Blue
//   "linear-gradient(to left, #b3e5fc 0%, #4fc3f7 100%)",  // Light Blue
//   "linear-gradient(to left, #81d4fa 0%, #29b6f6 100%)",  // Sky Blue
//   "linear-gradient(to left, #4fc3f7 0%, #03a9f4 100%)",  // Blue
//   "linear-gradient(to left, #29b6f6 0%, #0288d1 100%)",  // Medium Blue
//   "linear-gradient(to left, #03a9f4 0%, #0277bd 100%)",  // Deep Blue
//   "linear-gradient(to left, #0288d1 0%, #01579b 100%)",  // Dark Blue
// ];

//   return (
//     <Wrapper ref={exportRef}>
//       <Heading>Monthly Motor Runtime</Heading>

//       <LineWrapper>
//         {data.map((week, i) => (
//           <BoxWrapper key={i}>
//             <BoxValue>{week.run_time}</BoxValue>
//             <Box color={colors[i % colors.length]} />
//             <BoxLabel>Week {week.week}</BoxLabel>
//           </BoxWrapper>
//         ))}
//       </LineWrapper>

//       <TotalLabel>
//         <span>Total Monthly Runtime:</span>
//         <span>{total}</span>
//       </TotalLabel>
//     </Wrapper>
//   );
// });

// export default MotorMonthlyRuntimeChart;

import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import axios from "axios";
import moment from "moment";

const Wrapper = styled.div`
  background: white;
  padding: 2rem;
  // margin: 2rem auto;
  width: 100%;
  border-radius: 12px;
  // box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  // text-align: center;

  @media (max-width: 768px) {
    width: 95%;
    padding: 1rem;
  }
`;

const Container = styled.div`
  background-color: #fff;
  height: 100%;
  padding: 1rem;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  width: 100%;
  border-radius: 20px;
`;

const Heading = styled.h3`
  margin-bottom: 2.5rem;
  font-size: 1.5rem;
  color: #1a1a1a;
  font-weight: 600;
  text-align: left;
  letter-spacing: -0.02em;
`;

const LineWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 2rem 0 1rem;
  padding: 0 20px;
  flex-wrap: nowrap;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 10px;
    right: 10px;
    height: 2px;
    background: #e5e5e5;
    z-index: 0;

    @media (max-width: 768px) {
      display: none;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin: 2rem 0;
    padding: 0 10px;
  }
`;

const BoxWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 1rem;

  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }
`;

const BoxValue = styled.div`
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #2c2c2c;
  text-align: center;
  font-size: 0.95rem;
`;

const Box = styled.div`
  width: 100px;
  height: 40px;
  background: ${(props) => props.color};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  }

  @media (max-width: 768px) {
    width: 80px;
    height: 55px;
  }
`;

const BoxLabel = styled.div`
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
`;

const TotalLabel = styled.div`
  margin-top: 3rem;
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const TotalBox = styled.div`
  background: #e3f2fd;
  padding: 1.25rem 1.5rem;
  border-radius: 10px;
  min-width: 180px;
  font-weight: 600;
  text-align: center;
  font-size: 0.85rem;
  color: #1565c0;
  line-height: 1.6;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
`;

const SummarySection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1.5rem;

  @media (max-width: 768px) {
    gap: 0.8rem;
    margin-top: 1.25rem;
  }

  @media (max-width: 480px) {
    gap: 0.6rem;
    margin-top: 1rem;
  }
`;

export const SummaryCard = styled.div`
  flex: 1;
  min-width: 140px;
  background-color: ${(props) => props.bgColor || "#fff"};
  padding: 0.75rem 0.5rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  max-width: 180px;
  transition: all 0.3s ease;

  @media (max-width: 1024px) {
    padding: 0.7rem 0.45rem;
    max-width: 160px;
  }

  @media (max-width: 768px) {
    min-width: 120px;
    max-width: 140px;
    padding: 0.65rem 0.4rem;
  }

  @media (max-width: 480px) {
    min-width: 100px;
    max-width: 120px;
    padding: 0.6rem 0.35rem;
  }
`;

export const CardTitle = styled.h4`
  font-size: 0.75rem;
  color: #555;
  margin-bottom: 0.4rem;
  margin-top: 0;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 0.7rem;
    margin-bottom: 0.35rem;
  }

  @media (max-width: 480px) {
    font-size: 0.65rem;
    margin-bottom: 0.3rem;
  }
`;

export const CardValue = styled.h3`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${(props) => props.color || "#000"};
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.7rem;
  }
`;
const Highlight = styled.h3`
    color: #004080;
    margin-bottom:0.5rem;
`;

const MotorMonthlyRuntimeChart = forwardRef(({ motor_id, month, year, token, location_name }, ref) => {
  const exportRef = useRef();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState("");
  const [totalPower, setTotalPower] = useState("");
  const [loading, setLoading] = useState(true);
  const [totalCost, setTotalCost] = useState("");

  useImperativeHandle(ref, () => ({
    getElement: () => exportRef.current,
  }));

  // useEffect(() => {
  //   async function fetchMonthlyData() {
  //     if (!motor_id || !month || !year) return;

  //     setLoading(true);
  //     try {
  //       const url = `${process.env.REACT_APP_API}/sensor/motor-monthly-runtime?motor_id=${motor_id}&month=${month}&year=${year}`;
          
  //       const res = await axios.get(url, {
  //         headers: { Authorization: token[0] },
  //       });

  //       const logs = res.data.logs || [];
  //       setData(logs);
  //       setTotal(res.data.total_monthly_run_time || "0 mins");
  //       setTotalPower(res.data.total_power_consumption_kWh || "0 kWh");

  //       const rateUrl = `${process.env.REACT_APP_API}/user/unitrate/monthly/${org_id}/${year}/${month}`;
  //       const rateRes = await axios.get(rateUrl, {
  //         headers: { Authorization: token[0] },
  //       });

  //       const unitRate = rateRes.data?.data?.current_unit_rate || 7.35;

  //       const powerValue = parseFloat(res.data.total_power_consumption_kWh || 0);
  //       const cost = powerValue * unitRate;
  //       setTotalCost(cost.toFixed(2));
  //     } catch (err) {
  //       console.error("Error fetching monthly runtime:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }

  //   fetchMonthlyData();
  // }, [motor_id, month, year, token]);


  useEffect(() => {
  async function fetchMonthlyData() {
    if (!motor_id || !month || !year) return;

    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API}/sensor/motor-monthly-runtime?motor_id=${motor_id}&month=${month}&year=${year}`;
      const res = await axios.get(url, {
        headers: { Authorization: token[0] },
      });

      const logs = res.data.logs || [];
      setData(logs);
      setTotal(res.data.total_monthly_run_time || "0 mins");
      setTotalPower(res.data.total_power_consumption_kWh || "0 kWh");

      const org_id = localStorage.getItem("org_id");
      if (org_id) {
        const rateUrl = `${process.env.REACT_APP_API}/user/unitrate/monthly/${org_id}/${year}/${month}`;
        const rateRes = await axios.get(rateUrl, {
          headers: { Authorization: token[0] },
        });

        const unitRate = rateRes.data?.data?.current_unit_rate || 7.35;

        const powerValue = parseFloat(res.data.total_power_consumption_kWh || 0);
        const cost = powerValue * unitRate;
        setTotalCost(cost.toFixed(2));
      }
    } catch (err) {
      console.error("Error fetching monthly runtime:", err);
    } finally {
      setLoading(false);
    }
  }

  fetchMonthlyData();
}, [motor_id, month, year, token]);


  if (loading) return <Wrapper>Loading monthly runtime...</Wrapper>;

  // const colors = [
  //   "linear-gradient(to left, #CADAFB 0%, #92B8F6 100%)",
  //   "linear-gradient(to left, #B0C8F9 0%, #81A4F2 100%)",
  //   "linear-gradient(to left, #9CBDF7 0%, #7092E3 100%)",
  //   "linear-gradient(to left, #92B8F6 0%, #5775D1 100%)",
  //   "linear-gradient(to left, #7EA0E6 0%, #4664BE 100%)",
  //   "linear-gradient(to left, #6B89CF 0%, #324DA0 100%)",
  //   "linear-gradient(to left, #5775D1 0%, #1E3278 100%)",
  // ];

const colors = [
  "rgba(99, 155, 245, 0.7)",
  'rgba(163, 199, 244, 0.7)',
];

  const calcPower = (runTimeStr, hp = 3.5, efficiency = 0.75) => {
    const match = runTimeStr.match(/(\d+)\s*hour.*?(\d+)?\s*min/);
    if (!match) return 0;
    const hours = parseInt(match[1]) || 0;
    const mins = parseInt(match[2]) || 0;
    const totalHours = hours + mins / 60;
    const kWh = (hp * totalHours * 735.5) / (1000 * efficiency);
    return kWh.toFixed(2);
  };

  if (
  !loading &&
  (!data || data.length === 0 || !data.some((week) => week.run_time && week.run_time.trim() !== "" && week.run_time.trim() !== "0 mins"))
) {
  return (
      <Container>
      <p>
        No data available for this month.
      </p>
      </Container>
  );
}

  return (
    <Wrapper ref={exportRef}>
      <div>
      <Highlight>{location_name}</Highlight>
      <h5>Monthly Motor Runtine of {moment().month(month - 1).format("MMMM")}</h5>
    </div>


      <LineWrapper>
        {data
        .filter((week) => week.run_time && week.run_time.trim() !== "" && week.run_time.trim() !== "0 mins")
        .map((week, i) => {
          const weeklyPower = week.total_power_consumption_kWh || calcPower(week.run_time);
          return (
            <BoxWrapper key={i}>
              <BoxValue>{week.run_time}</BoxValue>
              <Box color={colors[i % colors.length]}>
              </Box>
              <BoxLabel>Week {week.week}</BoxLabel>
            </BoxWrapper>
          );
        })}
      </LineWrapper>

        <SummarySection>
        <SummaryCard bgColor="#e3f2fd">
          <CardTitle>Total Runtime</CardTitle>
          <CardValue color="#1e3a8a">{total}</CardValue>       
        </SummaryCard>

        <SummaryCard bgColor="#fff3e0">
          <CardTitle>Power Consumed</CardTitle>
          <CardValue color="#e65100">{totalPower} kWh</CardValue>
        </SummaryCard>

        <SummaryCard bgColor="#e8f5e9">
          <CardTitle>Total Cost</CardTitle>
          <CardValue color="#2e7d32">₹{totalCost}</CardValue>
        </SummaryCard>
      </SummarySection>
    </Wrapper>
  );
});

export default MotorMonthlyRuntimeChart;

// import React, { useEffect, useState, useMemo } from "react";
// import styled from "styled-components";
// import axios from "axios";
// import moment from "moment";

// const Wrapper = styled.div`
//   background: white;
//   padding: 2rem;
//   margin: 2rem auto;
//   width: 80%;
//   border-radius: 12px;
//   box-shadow: 0 4px 15px rgba(0,0,0,0.1);
//   text-align: center;

//   @media (max-width: 768px) {
//     width: 95%;
//     padding: 1rem;
//   }
// `;

// const Heading = styled.h3`
//   margin-bottom: 2rem;
//   font-size: 1.2rem;
//   color: #be6f72;
//   font-weight: bold;
// `;

// const LineWrapper = styled.div`
//   position: relative;
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-start;
//   margin: 2rem 0 1rem;
//   padding: 0 20px;

//   &::before {
//     content: "";
//     position: absolute;
//     top: 50%;
//     left: 10px;
//     right: 10px;
//     height: 4px;
//     background: #ddd;
//     z-index: 0;
//   }
// `;

// const BoxWrapper = styled.div`
//   position: relative;
//   z-index: 1;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// `;

// const BoxValue = styled.div`
//   margin-bottom: 0.3rem;
//   font-weight: bold;
//   color: #333;
// `;

// const Box = styled.div`
//   width: 80px;
//   height: 30px;
//   background: ${(props) => props.color};
//   border-radius: 6px;
// `;

// const BoxLabel = styled.div`
//   margin-top: 0.3rem;
//   font-size: 0.95rem;
//   color: #444;
// `;

// const TotalLabel = styled.div`
//   margin-top: 2rem;
//   font-weight: bold;
//   font-size: 1rem;
//   color: #be6f72;

//   @media (max-width: 768px) {
//     font-size: 1rem;
//   }
// `;

// const Skeleton = styled.div`
//   background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
//   background-size: 200% 100%;
//   animation: loading 1.5s infinite;
//   border-radius: 6px;
//   height: ${props => props.height || '20px'};
//   width: ${props => props.width || '100%'};
//   margin: ${props => props.margin || '0'};

//   @keyframes loading {
//     0% { background-position: 200% 0; }
//     100% { background-position: -200% 0; }
//   }
// `;

// const ErrorMessage = styled.div`
//   color: #d32f2f;
//   padding: 1rem;
//   text-align: center;
// `;

// const COLORS = ["#b8f5a2","#fff59d","#ffbc99","#a8e8ff","#d2b3ff","#ffd6e7","#ff9b9b"];

// const MotorMonthlyRuntimeChart = ({ motor_id, month, year, token, startDate }) => {
//   const [data, setData] = useState([]);
//   const [total, setTotal] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [retryCount, setRetryCount] = useState(0);

//   useEffect(() => {
//     const source = axios.CancelToken.source();
//     let timeoutId;
    
//     async function fetchMonthlyData(attempt = 0) {
//       if (!motor_id || !month || !year) {
//         console.log('Missing required params:', { motor_id, month, year });
//         setLoading(false);
//         return;
//       }

//       setLoading(true);
//       setError(null);
      
//       try {
//         // Try the monthly endpoint first
//         let url = `${process.env.REACT_APP_API}/sensor/motor-monthly-runtime?motor_id=${motor_id}&month=${month}&year=${year}`;
//         console.log(`Attempt ${attempt + 1}: Fetching from:`, url);
        
//         let res;
//         try {
//           res = await axios.get(url, {
//             headers: { Authorization: token[0] },
//             cancelToken: source.token,
//             timeout: 60000 // Increased to 60 seconds
//           });
//         } catch (firstErr) {
//           console.log('First endpoint failed, trying fallback...');
          
//           // Fallback: try using date range endpoint if monthly endpoint fails
//           if (startDate) {
//             const start = moment(startDate).startOf('month').format('YYYY-MM-DD');
//             const end = moment(startDate).endOf('month').format('YYYY-MM-DD');
//             url = `${process.env.REACT_APP_API}/sensor/motor-runtime?motor_id=${motor_id}&start_date=${start}&end_date=${end}`;
//             console.log('Trying fallback URL:', url);
            
//             res = await axios.get(url, {
//               headers: { Authorization: token[0] },
//               cancelToken: source.token,
//               timeout: 60000
//             });
//           } else {
//             throw firstErr;
//           }
//         }

//         console.log('Response received:', res.data);

//         const logs = res.data.logs || res.data.data || [];
//         const totalTime = res.data.total_monthly_run_time || res.data.total_runtime || "0 mins";
        
//         setData(logs);
//         setTotal(totalTime);
//         setLoading(false);
//         setRetryCount(0);
//       } catch (err) {
//         if (axios.isCancel(err)) {
//           console.log('Request cancelled');
//           return;
//         }

//         console.error("Error fetching monthly runtime:", err);
//         console.error("Error details:", {
//           message: err.message,
//           response: err.response?.data,
//           status: err.response?.status,
//           code: err.code
//         });

//         // Auto-retry on timeout (max 2 retries)
//         if (err.code === 'ECONNABORTED' && attempt < 2) {
//           console.log(`Timeout occurred. Retrying in 2 seconds... (Attempt ${attempt + 2}/3)`);
//           setRetryCount(attempt + 1);
//           timeoutId = setTimeout(() => {
//             fetchMonthlyData(attempt + 1);
//           }, 2000);
//           return;
//         }
        
//         let errorMsg;
//         if (err.code === 'ECONNABORTED') {
//           errorMsg = "Request timed out. The server is taking too long to respond. Please try again or contact support if the issue persists.";
//         } else {
//           errorMsg = err.response?.data?.message 
//             || err.response?.statusText
//             || err.message
//             || "Failed to load monthly runtime data";
//         }
        
//         setError(errorMsg);
//         setLoading(false);
//         setRetryCount(0);
//       }
//     }

//     fetchMonthlyData();

//     return () => {
//       source.cancel('Component unmounted');
//       if (timeoutId) clearTimeout(timeoutId);
//     };
//   }, [motor_id, month, year, token, startDate]);

//   // Memoize the rendered week boxes to prevent unnecessary re-renders
//   const weekBoxes = useMemo(() => {
//     return data.map((week, i) => (
//       <BoxWrapper key={`week-${week.week}-${i}`}>
//         <BoxValue>{week.run_time}</BoxValue>
//         <Box color={COLORS[i % COLORS.length]} />
//         <BoxLabel>Week {week.week}</BoxLabel>
//       </BoxWrapper>
//     ));
//   }, [data]);

//   if (loading) {
//     return (
//       <Wrapper>
//         <Heading>Monthly Motor Runtime</Heading>
//         {retryCount > 0 ? (
//           <div style={{ padding: '2rem', color: '#666' }}>
//             Loading... (Attempt {retryCount + 1}/3)
//             <br />
//             <small>Server is responding slowly, please wait...</small>
//           </div>
//         ) : (
//           <>
//             <Skeleton height="30px" margin="2rem 0" />
//             <Skeleton height="20px" width="60%" margin="1rem auto" />
//             <Skeleton height="20px" width="40%" margin="1rem auto" />
//           </>
//         )}
//       </Wrapper>
//     );
//   }

//   if (error) {
//     return (
//       <Wrapper>
//         <Heading>Monthly Motor Runtime</Heading>
//         <ErrorMessage>
//           {error}
//           <div style={{ marginTop: '1rem' }}>
//             <button 
//               onClick={() => window.location.reload()} 
//               style={{
//                 padding: '0.5rem 1rem',
//                 background: '#be6f72',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '5px',
//                 cursor: 'pointer'
//               }}
//             >
//               Retry
//             </button>
//           </div>
//         </ErrorMessage>
//       </Wrapper>
//     );
//   }

//   if (data.length === 0) {
//     return (
//       <Wrapper>
//         <Heading>Monthly Motor Runtime</Heading>
//         <div style={{ padding: '2rem', color: '#666' }}>
//           No runtime data available for this month
//         </div>
//       </Wrapper>
//     );
//   }

//   return (
//     <Wrapper>
//       <Heading>Monthly Motor Runtime</Heading>
//       <LineWrapper>
//         {weekBoxes}
//       </LineWrapper>
//       <TotalLabel>Total Monthly Runtime: {total}</TotalLabel>
//     </Wrapper>
//   );
// };

// export default React.memo(MotorMonthlyRuntimeChart);